import { storageService } from '@/services'

export const state = () => ({
  profileUpdate: {},
  profileChangePassword: {},
  profileSendEmail: {},
  profileVerifyEmail: {},
  profileSendPhone: {},
  profileVerifyPhone: {},
  profileUpload: {},
  documentStatus: {},
  verifyInn: {},
  isCheckSmsAvailability: false,
  dateEndSms: 0,
  isFetchingAllDocument: true,
})

export const mutations = {
  SET_PROFILE_UPDATE: (state, { profileUpdate }) => {
    state.profileUpdate = profileUpdate
  },
  SET_PROFILE_CHANGE_PASSWORD: (state, { profileChangePassword }) => {
    state.profileChangePassword = profileChangePassword
  },
  SET_PROFILE_SEND_EMAIL: (state, { profileSendEmail }) => {
    state.profileSendEmail = profileSendEmail
  },
  SET_PROFILE_VERIFY_EMAIL: (state, { profileVerifyEmail }) => {
    state.profileVerifyEmail = profileVerifyEmail
  },
  SET_PROFILE_SEND_PHONE: (state, { profileSendPhone }) => {
    state.profileSendPhone = profileSendPhone
    if (profileSendPhone?.errors?.timeMs) {
      state.dateEndSms = profileSendPhone.errors.timeMs
    }
    else {
      state.dateEndSms = profileSendPhone.time
    }
  },

  SET_PROFILE_VERIFY_PHONE: (state, { profileVerifyPhone }) => {
    state.profileVerifyPhone = profileVerifyPhone
  },
  SET_PROFILE_UPLOAD_DOCUMENT: (state, { profileUpload }) => {
    state.profileUpload = profileUpload
  },
  SET_DOCUMENT_STATUS: (state, { documentStatus }) => {
    state.documentStatus = documentStatus
  },
  SET_VERIFY_INN: (state, { verifyInn }) => {
    state.verifyInn = verifyInn
  },
  setCheckSmsAvailability(state, data) {
    state.isCheckSmsAvailability = data
    state.dateEndSms = data.time
  },
  setTimeUpDateEndSms(state) {
    state.dateEndSms = 0
  },
  set_isFetchingAllDocument(state, status) {
    state.isFetchingAllDocument = status
  },
}

export const actions = {
  PROFILE_UPDATE: async function({ commit }, data) {
    const res = await this.$api.profile.profileUpdate(data)
    commit('SET_PROFILE_UPDATE', { profileUpdate: res.data })
  },
  DOCUMENT_STATUS: async function({ commit }) {
    const res = await this.$api.user_documents.checkDocumentStatus()
    commit('SET_DOCUMENT_STATUS', { documentStatus: res.data })
  },
  PROFILE_UPLOAD_DOCUMENT: async function({ commit }, data) {
    const res = await this.$api.user_documents.uploadDocument(data)
    commit('SET_PROFILE_UPLOAD_DOCUMENT', { profileUpload: res.data })
  },
  async PROFILE_CHANGE_PASSWORD({ commit }, data) {
    commit('SET_PROFILE_CHANGE_PASSWORD', { profileChangePassword: {} })
    const res = await this.$api.auth.profileChangePassword(data)
    if (res.data.status) {
      const token = res.data.token
      storageService.saveToken(token)
      commit('user/SET_USER_TOKEN', null, { root: true })
      this.$api.$commonToken = token
    }
    commit('SET_PROFILE_CHANGE_PASSWORD', { profileChangePassword: res.data })
  },
  reset_profileChangePassword({ commit }) {
    commit('SET_PROFILE_CHANGE_PASSWORD', { profileChangePassword: {} })
  },
  PROFILE_SEND_EMAIL: async function({ commit }, data) {
    const res = await this.$api.auth.profileSendEmailConfirm(data)
    commit('SET_PROFILE_SEND_EMAIL', { profileSendEmail: res.data })
  },

  PROFILE_VERIFY_EMAIL: async function({ commit }, data) {
    const res = await this.$api.auth.profileVerifyEmail(data)
    commit('SET_PROFILE_VERIFY_EMAIL', { profileVerifyEmail: res.data })
  },
  PROFILE_VERIFY_PHONE: async function({ commit }, data) {
    const res = await this.$api.auth.profileVerifyPhone(data)
    commit('SET_PROFILE_VERIFY_PHONE', { profileVerifyPhone: res.data })
    return res?.data?.status
  },
  PROFILE_SEND_PHONE: async function({ commit }, data) {
    const res = await this.$api.auth.profileSendPhoneConfirm(data)
    commit('SET_PROFILE_SEND_PHONE', { profileSendPhone: res.data })
  },
  VERIFY_INN: async function({ commit }, data) {
    const res = await this.$api.profile.verifyInn(data)
    commit('SET_VERIFY_INN', { verifyInn: res.data })
    return res.data
  },
  async checkSmsAvailability({ commit }) {
    try {
      const res = await this.$api.auth.checkSmsAvailability()
      commit('setCheckSmsAvailability', res.data)
    }
    catch (e) {
      console.log(e)
    }
  },
  timeUpDateEndSms({ commit }) {
    commit('setTimeUpDateEndSms')
  },
  toggle_isFetchingAllDocument({ commit }, status) {
    commit('set_isFetchingAllDocument', status)
  },
}

export const getters = {
  GET_DOCUMENT_STATUS: state => state.documentStatus,
  GET_PROFILE_UPDATE: state => state.profileUpdate,
  GET_PROFILE_UPLOAD_DOCUMENT: state => state.profileUpload,
  get_profileChangePassword: state => state.profileChangePassword,
  GET_PROFILE_SEND_EMAIL: state => state.profileSendEmail,
  GET_PROFILE_VERIFY_EMAIL: state => state.profileVerifyEmail,
  GET_PROFILE_SEND_PHONE: state => state.profileSendPhone,
  GET_PROFILE_VERIFY_PHONE: state => state.profileVerifyPhone,
  getCheckSmsAvailability: state => state.isCheckSmsAvailability,
  getDateEndSms: state => state.dateEndSms,
  get_isFetchingAllDocument: state => state.isFetchingAllDocument,
}
